import React from 'react';
import { Card, Row, Col, Tag, Alert } from 'antd';
import { motion } from 'framer-motion';
import { 
  SendOutlined,
  ThunderboltOutlined,
  GlobalOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';

const RouteMap: React.FC = () => {
  return (
    <section id="route-map" style={{ 
      padding: '80px 0', 
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      color: 'white',
      position: 'relative'
    }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: 'center', marginBottom: '60px' }}
        >
          <h2 className="display-medium" style={{ 
            marginBottom: '24px',
            color: 'white'
          }}>
            318空运专线的线路
          </h2>
          <p className="body-large" style={{ 
            color: 'rgba(255, 255, 255, 0.9)', 
            maxWidth: '800px', 
            margin: '0 auto',
            fontSize: '1.125rem'
          }}>
            覆盖美国主要机场，普货与带电货物分线操作，确保运输安全高效
          </p>
        </motion.div>

        <Row gutter={[32, 32]}>
          {/* 普货线路 */}
          <Col xs={24} lg={12}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Card
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: 'none',
                  borderRadius: '16px',
                  height: '100%'
                }}
                bodyStyle={{ padding: '32px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <SendOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
                  <h3 style={{ 
                    color: '#1D1D1F',
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    marginBottom: '8px'
                  }}>
                    普货：大陆起飞
                  </h3>
                  <Tag color="blue" style={{ fontSize: '14px' }}>常规货物专线</Tag>
                </div>

                <div style={{ 
                  background: '#f0f9ff', 
                  padding: '20px', 
                  borderRadius: '12px',
                  marginBottom: '20px'
                }}>
                  <h4 style={{ color: '#1890ff', marginBottom: '16px', textAlign: 'center' }}>
                    目的地机场
                  </h4>
                  <Row gutter={[12, 12]}>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #1890ff'
                      }}>
                        <div style={{ fontWeight: '600', color: '#1890ff' }}>美西洛杉矶机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#1890ff' }}>SFO</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #52c41a'
                      }}>
                        <div style={{ fontWeight: '600', color: '#52c41a' }}>美中东达机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#52c41a' }}>ORD</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #faad14'
                      }}>
                        <div style={{ fontWeight: '600', color: '#faad14' }}>美西洛杉矶机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#faad14' }}>LAX</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #722ed1'
                      }}>
                        <div style={{ fontWeight: '600', color: '#722ed1' }}>美中东达机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#722ed1' }}>ORD/JFK</div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Alert
                  message="普货渠道特点"
                  description="主要是飞SFO，市场主流是飞LAX，SFO相对来说清关查验情况少"
                  type="info"
                  showIcon
                  style={{ marginBottom: '16px' }}
                />

                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  gap: '16px',
                  flexWrap: 'wrap'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <ClockCircleOutlined style={{ color: '#52c41a' }} />
                    <span style={{ fontSize: '12px', color: '#666' }}>每周3个航班左右</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                    <span style={{ fontSize: '12px', color: '#666' }}>基本交货之后3天左右会有航班起飞</span>
                  </div>
                </div>
              </Card>
            </motion.div>
          </Col>

          {/* 带电线路 */}
          <Col xs={24} lg={12}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Card
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: 'none',
                  borderRadius: '16px',
                  height: '100%'
                }}
                bodyStyle={{ padding: '32px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <ThunderboltOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
                  <h3 style={{ 
                    color: '#1D1D1F',
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    marginBottom: '8px'
                  }}>
                    带电：香港起飞
                  </h3>
                  <Tag color="orange" style={{ fontSize: '14px' }}>带电产品专线</Tag>
                </div>

                <div style={{ 
                  background: '#fff7e6', 
                  padding: '20px', 
                  borderRadius: '12px',
                  marginBottom: '20px'
                }}>
                  <h4 style={{ color: '#faad14', marginBottom: '16px', textAlign: 'center' }}>
                    目的地机场
                  </h4>
                  <Row gutter={[12, 12]}>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #1890ff'
                      }}>
                        <div style={{ fontWeight: '600', color: '#1890ff' }}>美西洛杉矶机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#1890ff' }}>LAX</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #52c41a'
                      }}>
                        <div style={{ fontWeight: '600', color: '#52c41a' }}>美西旧金山机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#52c41a' }}>SFO</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #722ed1'
                      }}>
                        <div style={{ fontWeight: '600', color: '#722ed1' }}>纽约肯尼迪机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#722ed1' }}>JFK</div>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ 
                        background: 'white', 
                        padding: '12px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        border: '2px solid #f5222d'
                      }}>
                        <div style={{ fontWeight: '600', color: '#f5222d' }}>芝加哥机场</div>
                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#f5222d' }}>ORD</div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Alert
                  message="带电渠道特点"
                  description="香港航班飞LAX/SFO/JFK/ORD，专业处理带电产品运输"
                  type="warning"
                  showIcon
                  style={{ marginBottom: '16px' }}
                />

                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  gap: '16px',
                  flexWrap: 'wrap'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <ThunderboltOutlined style={{ color: '#faad14' }} />
                    <span style={{ fontSize: '12px', color: '#666' }}>专业带电产品渠道</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                    <span style={{ fontSize: '12px', color: '#666' }}>符合国际航空运输标准</span>
                  </div>
                </div>
              </Card>
            </motion.div>
          </Col>
        </Row>

        {/* 服务特点 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          style={{ marginTop: '60px' }}
        >
          <Card
            style={{
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: 'none',
              borderRadius: '16px'
            }}
            bodyStyle={{ padding: '40px' }}
          >
            <Row gutter={[32, 32]} align="middle">
              <Col xs={24} md={8}>
                <div style={{ textAlign: 'center' }}>
                  <GlobalOutlined style={{ fontSize: '64px', color: '#52c41a', marginBottom: '16px' }} />
                  <h3 style={{ color: '#1D1D1F', marginBottom: '12px' }}>全程透明</h3>
                  <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
                    无暗箱操作，客户真正的放心
                  </p>
                </div>
              </Col>
              
              <Col xs={24} md={8}>
                <div style={{ textAlign: 'center' }}>
                  <CheckCircleOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '16px' }} />
                  <h3 style={{ color: '#1D1D1F', marginBottom: '12px' }}>稳定航班</h3>
                  <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
                    每周3个航班左右，基本交货之后3天左右会有航班起飞
                  </p>
                </div>
              </Col>
              
              <Col xs={24} md={8}>
                <div style={{ textAlign: 'center' }}>
                  <ClockCircleOutlined style={{ fontSize: '64px', color: '#faad14', marginBottom: '16px' }} />
                  <h3 style={{ color: '#1D1D1F', marginBottom: '12px' }}>快速清关</h3>
                  <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
                    SFO相对来说清关查验情况少，通关效率更高
                  </p>
                </div>
              </Col>
            </Row>
          </Card>
        </motion.div>
      </div>

      {/* 背景装饰 */}
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '-10%',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }} />
      
      <div style={{
        position: 'absolute',
        bottom: '20%',
        right: '0%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }} />
    </section>
  );
};

export default RouteMap;

